import {Modal} from "@shopify/polaris";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from '../../../../utils/utils'
import intl from "../../../../i18n/intl";
const UpgradePlanModal = ({pointData,setPointData}) => {
    const router  = useHistory()

  return (
    <div className="upgrade_new_feature">
      <Modal
        open={pointData.less}
        onClose={() => setPointData((prevValue)=>({...prevValue,less:false}))}
        title={intl.get('Insufficient Points')}
        primaryAction={{
          content: intl.get("Earn Points"),
          onAction: () => {
            setPointData((prevValue)=>({...prevValue,less:false}))
            utils.routeListen('/admin/points')
            utils.routeJump1(router,'/admin/points')
          },
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () =>  setPointData((prevValue)=>({...prevValue,less:false})),
          },
        ]}
      >
        <Modal.Section>
        <p style={{margin:"10px",fontSize:'14px'}}>{`The AI optimization requires 20 points each time, but you don’t have enough points. You can try to earn more points and try again. (Remaining points: ${pointData.points})`}</p>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default UpgradePlanModal;
